var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-chip',[_c('v-icon',{attrs:{"left":""}},[_vm._v("mdi-account-circle")]),_vm._v(" "+_vm._s(_vm.author.displayName)+" ")],1)}
var staticRenderFns = []

export { render, staticRenderFns }